import { useQuery } from '@tanstack/react-query';
import { engagementService } from '../services/engagement.service';

export function useEngagementTickets() {
  return useQuery({
    queryKey: ['engagement', 'current-cycle-tickets'],
    queryFn: () => engagementService.getCurrentCycleTickets(),
  });
}

export function useCycleHistory(page = 1, limit = 10, options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ['engagement', 'cycle-history', page, limit],
    queryFn: () => engagementService.getCycleHistory({ page, limit }),
    enabled: options?.enabled,
  });
}

export function useCycleTickets(cycleKey: string) {
  return useQuery({
    queryKey: ['engagement', 'cycle-tickets', cycleKey],
    queryFn: () => engagementService.getCycleTickets(cycleKey),
    enabled: Boolean(cycleKey),
  });
}
